import { Col, Form, FormInstance, Row } from 'antd';
import classNames from 'classnames';
import { ReactNode } from 'react';

import { Button } from 'components';

interface IProps {
  okTitle?: string;
  form: FormInstance<any>;
  children: ReactNode;
  customClass?: string;
  disabled?: boolean;
  onCancel: () => void;
  onFinish(values: any): void;
}

const FormFilter = ({
  okTitle = 'Tìm kiếm',
  form,
  children,
  customClass = '',
  disabled,
  onCancel,
  onFinish,
}: IProps) => {
  const classes = classNames(customClass, 'mt-4');

  return (
    <div className={classes}>
      <Form
        form={form}
        size="small"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        {children}
        <Row gutter={[12, 12]} className="mt-2" justify={'end'}>
          <Col>
            <Button
              title="Hủy"
              type="button"
              handleOnclick={onCancel}
              disabled={disabled}
            />
          </Col>
          <Col>
            <Button fill title={okTitle} type="submit" disabled={disabled} />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FormFilter;
